import { Injectable } from '@angular/core';
import { ApmService } from '@elastic/apm-rum-angular'
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ElasticService {

  apm: any;

  constructor(private apmService: ApmService) { }


  initElk() {
    if (this.apm) return;
    // this.apm = this.apmService.init({
    //   serviceName: 'MallGo Facturas',
    //   serverUrl: 'https://rum.inkremental.co',
    //   environment: environment.production ? document.location.hostname : 'development',
    // });
  }


  setUserContext(userId: string | undefined, email: string | undefined, username: string | undefined) {
    console.debug('setUserContext', userId, email, username);
    // this.apm.setUserContext({
    //   'email': email,
    //   'username': username,
    //   'id': userId
    // });
  }


}
